// --- Vendors ---
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded'; // <--- IMPORTANT : Importer ceci
import GLightbox from 'glightbox';

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

const corbeille = {
    readyFn: function () {
        console.log("corbeille ready");

        const gridContainer = document.querySelector('.grid-media');
        const loader = document.getElementById('gallery-loader');

        // 1. On garde le loader visible pour cacher le "bazar" initial
        if (loader) {
            loader.style.display = 'flex';
            loader.style.opacity = '1';
        }

        // 2. On bloque le scroll LE TEMPS DU CHARGEMENT (Uniquement)
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';

        if (gridContainer) {
            // 3. Mélanger les éléments
            const items = Array.from(gridContainer.querySelectorAll('.grid-item'));
            const shuffledItems = shuffleArray(items);
            shuffledItems.forEach(item => gridContainer.appendChild(item));

            // 4. UTILISATION DE IMAGESLOADED
            // On attend que TOUTES les images soient chargées avant de toucher à Isotope
            imagesLoaded(gridContainer, function () {

                console.log("Toutes les images chargées. Lancement d'Isotope.");

                // 5. Initialiser Isotope MAINTENANT (les hauteurs sont connues)
                const iso = new Isotope(gridContainer, {
                    itemSelector: '.grid-item',
                    masonry: {
                        columnWidth: '.grid-sizer'
                    }
                });

                // 6. Débloquer le scroll et cacher le loader
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.width = '';

                // Petit délai pour que le navigateur enregistre le déblocage
                setTimeout(() => {
                    if (loader) {
                        loader.style.opacity = '0';
                        loader.style.transition = 'opacity 0.5s ease';
                        setTimeout(() => {
                            loader.style.display = 'none';
                        }, 500);
                    }

                    // Layout de sécurité (souvent inutile avec imagesLoaded mais prudent)
                    iso.layout();
                }, 100);

                // 7. Initialiser GLightbox
                GLightbox({
                    selector: '.glightbox3',
                    loop: true,
                    touchNavigation: true,
                });

            });
        }
    }
}

export { corbeille };